module.exports = __webpack_public_path__ + "static/img/small.c7244947.svg";